import { Box, Typography, styled } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import React from "react";

function CoinSelectItem({ data }) {
  return (
    <CoinSelectItemWrapper
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <img
        width="20px"
        height="20px"
        src={DefaultUrlWeb + data?.imageUrl}
        alt=""
      />
      <Typography variant="h6">{data?.name}</Typography>
    </CoinSelectItemWrapper>
  );
}

const CoinSelectItemWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  img: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export default CoinSelectItem;
